import { render, staticRenderFns } from "./Medewerker.vue?vue&type=template&id=2291edb6&scoped=true&"
import script from "./Medewerker.vue?vue&type=script&lang=js&"
export * from "./Medewerker.vue?vue&type=script&lang=js&"
import style0 from "./Medewerker.vue?vue&type=style&index=0&id=2291edb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2291edb6",
  null
  
)

export default component.exports